import React, { useRef } from 'react';

import CommonImage from '@/components/CommonImage';
import CustomDropdown from '@/components/CustomDropdown';
import {
	BODY_TYPE_OPTIONS,
	GENDER_OPTIONS,
	HAIR_TYPE_OPTIONS,
	NATIONALITY_OPTIONS,
	ZOOM_OPTIONS
} from '@/features/designTool/constants';

const PromptForm = ({
	selectedOptions,
	setSelectedOptions,
	usedPromptCount = 0,
	description,
	setDescription,
	parentCatergory
}) => {
	const descriptionRef = useRef(null);

	const handleRemarksChange = (e) => {
		setDescription(e.target.value);

		e.target.style.height = 'auto';
		e.target.style.height = `${e.target.scrollHeight}px`;
	};

	const isBottom = () => parentCatergory === 'BOTTOM';

	return (
		<div className="generate-model-content mt-4">
			<div className="generate-header">
				<p className="semibold-14 gray_dark_01">AI Model Generate</p>
			</div>
			<div>
				<p className="regular-14 gray_dark_02 pt-2 ml-4 d-flex align-items-center justify-content-between mr-4">
					<span className="regular-14 gray_dark_02">Generation limit:</span>{' '}
					<span className="regular-14 gray_dark_02">{usedPromptCount}/2</span>
				</p>
				<div className="model-coverage">
					<div>
						<label className="regular-14 gray_dark_02 pb-1">*Nationality</label>
						<CustomDropdown
							items={NATIONALITY_OPTIONS}
							title="Select Nationality"
							onItemClick={(item) =>
								setSelectedOptions((prev) => ({ ...prev, nationality: item }))
							}
							selectedItem={selectedOptions.nationality?.value}
							isShowSearch={true}
							toolTipLength={100}
						/>
					</div>
					<div className="mt-3">
						<label className="regular-14 gray_dark_02 pb-1">*Gender</label>
						<CustomDropdown
							items={GENDER_OPTIONS}
							title="Select Gender"
							onItemClick={(item) => setSelectedOptions((prev) => ({ ...prev, gender: item }))}
							selectedItem={selectedOptions.gender?.value}
							isShowSearch={true}
							toolTipLength={100}
						/>
					</div>

					<div className="mt-3">
						<label className="regular-14 gray_dark_02 pb-1">Hair type (optional)</label>
						<CustomDropdown
							items={HAIR_TYPE_OPTIONS}
							title="Select Hair Type"
							onItemClick={(item) =>
								setSelectedOptions((prev) => ({ ...prev, hairType: item }))
							}
							selectedItem={selectedOptions.hairType?.value}
							isShowSearch={true}
							toolTipLength={100}
							isDisabled={isBottom()}
						/>
					</div>
					<div className="mt-3">
						<label className="regular-14 gray_dark_02 pb-1">Body type (optional)</label>
						<CustomDropdown
							items={BODY_TYPE_OPTIONS}
							title="Select Body Type"
							onItemClick={(item) =>
								setSelectedOptions((prev) => ({ ...prev, bodyType: item }))
							}
							selectedItem={selectedOptions.bodyType?.value}
							isShowSearch={true}
							toolTipLength={100}
							isDisabled={isBottom()}
						/>
					</div>
					<div className="mt-3">
						<label htmlFor="description" className="regular-14 gray_dark_02 pb-1">
							Description (optional)
						</label>
						<div className="form-group">
							<textarea
								ref={descriptionRef}
								placeholder="Write Style Description"
								name="description"
								type="text"
								value={description}
								onChange={handleRemarksChange}
								rows={1}
								style={{
									resize: 'none',
									overflow: 'hidden',
									height: '36px',
									padding: '8px 12px'
								}}
							/>
						</div>
					</div>

					<p className="regular-14 gray_dark_02 pt-3 pb-1">Camera Zoom</p>
					<div className="all-side-items">
						{ZOOM_OPTIONS.filter((item) =>
							isBottom() ? item.id !== 1 && item.id !== 2 : true
						).map((item) => (
							<div
								className={`single-side d-flex flex-column justify-content-center align-items-center cursor-pointer ${
									item.value === selectedOptions.zoomOption?.value ? 'active' : ''
								}`}
								key={item.id}
								onClick={() => setSelectedOptions((prev) => ({ ...prev, zoomOption: item }))}
							>
								<CommonImage src={item.imagePath} alt="Front Image" isStatic={false} />
								<p className="regular-14 gray_dark_03">{item.name}</p>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default PromptForm;
